import { apiUrl } from "./api";
import { AchievementsResponse } from "../types/achievements";

export interface RecentAchievementItem {
  achievement_id: string;
  achievement_name: string;
  achievement_description?: string | null;
  pilot_uid: string | null;
  pilot_name: string | null;
  earned_at: string | null;
}

export interface RecentAchievementsResponse {
  achievements: RecentAchievementItem[];
}

export async function fetchAchievements(pilotUid?: string): Promise<AchievementsResponse> {
  const url = apiUrl("/achievements");
  if (pilotUid) url.searchParams.set("pilot_uid", pilotUid);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch achievements: ${response.status}`);
  return response.json();
}

export async function fetchRecentAchievements(params: { limit?: number; period?: "all_time" | "this_month" } = {}): Promise<RecentAchievementsResponse> {
  const url = apiUrl("/achievements/recent");
  if (params.limit != null) {
    url.searchParams.set("limit", String(params.limit));
  }
  if (params.period && params.period !== "all_time") {
    url.searchParams.set("period", params.period);
  }

  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch recent achievements: ${response.status}`);
  return response.json();
}
